/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Which stream sources surface as POVs. TOURNAMENT = only tournament-managed featured streams; INDIVIDUAL = only participant-toggled connected channels; BOTH = both.
 * @export
 */
export const StreamingMode = {
    TOURNAMENT: 'TOURNAMENT',
    INDIVIDUAL: 'INDIVIDUAL',
    BOTH: 'BOTH'
} as const;
export type StreamingMode = typeof StreamingMode[keyof typeof StreamingMode];


export function instanceOfStreamingMode(value: any): boolean {
    for (const key in StreamingMode) {
        if (Object.prototype.hasOwnProperty.call(StreamingMode, key)) {
            if (StreamingMode[key as keyof typeof StreamingMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreamingModeFromJSON(json: any): StreamingMode {
    return StreamingModeFromJSONTyped(json, false);
}

export function StreamingModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamingMode {
    return json as StreamingMode;
}

export function StreamingModeToJSON(value?: StreamingMode | null): any {
    return value as any;
}

export function StreamingModeToJSONTyped(value: any, ignoreDiscriminator: boolean): StreamingMode {
    return value as StreamingMode;
}

